import { Stack, Typography, Box, Button, useMediaQuery } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import ClientButton from '../../common/Clientbutton';
import { ClientOptionButton } from '../../common/ClientOptionButton';
import StepsHeading from '../../common/StepsHeading';
import { useState } from 'react';
import CommonErrorMessage from '../../common/CommonErrorMessage';

export default function WellnessGoals({ userData, setUserData, onNext }) {
    const { theme } = useClient();
    const [formError, setFormError] = useState("");
    const isLargeScreen = useMediaQuery('(min-width:600px)');
    const handleOptionToggle = (value) => {
        const currentGoals = userData?.wellnessGoal || [];
        const isSelected = currentGoals.includes(value);

        const updatedGoals = isSelected
            ? currentGoals.filter(goal => goal !== value) // remove if already selected
            : [...currentGoals, value]; // add if not selected

        setUserData({ ...userData, wellnessGoal: updatedGoals });

        // Optional: if you want to trigger onNext after at least one selection
        // if (!isSelected && updatedGoals.length === 1) onNext();
    };

    const handleNextStep = () => {
        let isValid = true;
        if (!userData.wellnessGoal?.length) {
            setFormError("Please add details");
            isValid = false;
        }
        if (isValid) {
            onNext()
        }
    };

    const onClickSkip = () => {
        setFormError("");
        setUserData((prevState) => ({
            ...prevState,
            wellnessGoal: [],
        }));
        onNext();
    }

    return (
        <>
            <Stack
                spacing={2}
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                }}
            >
                {/* <Typography
                    sx={{
                        fontSize: { xs: '20px', sm: '23px', md: '26px' },
                        fontWeight: "700",
                        lineHeight: { xs: '24px', sm: '27px', md: '32px' },
                        textAlign: "center",
                        px: { xs: 1, sm: 4 },
                        width: '100%',
                        paddingTop: { xs: "10px", sm: 1 },
                        marginBottom: "10px"
                    }}
                >
                    What are your wellness goals?
                </Typography> */}
                <StepsHeading title={"What are your wellness goals?"} />
                {[
                    { label: "More physical energy and mental clarity", value: "more physical energy and mental clarity" },
                    { label: "Better moods and less stress", value: "better moods and less stress" },
                    { label: "Improve my daily digestion and gut health", value: "improve my daily digestion and gut health" },
                    { label: "Build a stronger immune system for less sick days", value: "build a stronger immune system for less sick days" },
                    { label: "Feel calmer before bed and get more restful sleep", value: "feel calmer before bed and get more restful sleep" },
                    { label: "Give me foundational nutrition", value: "give me foundational nutrition" }
                ].map((option, index) => {
                    // const isSelected = userData?.wellnessGoal?.includes(option.value);

                    return (
                        <ClientOptionButton
                            onClick={() => handleOptionToggle(option.value)}
                            key={index}
                            option={option.label}
                            isSelected={userData?.wellnessGoal?.includes(option.value)}
                            optionSelectSingleValue={userData?.wellnessGoal}  // Pass the current selected value
                            value={option.value}  // Pass value to compare with userData
                            optionSx={{
                                padding: '2px ',
                                fontSize: {
                                    xs: '12px',
                                    sm: '15px',
                                    md: '16px',
                                    lg: "16px"
                                }
                            }}
                            optionBtnSx={{
                                width: { xs: '98%', sm: '400px', lg: '450px', md: '450px' },
                                // boxShadow: "rgba(0, 0, 0, 0.15) 0px 1px",
                                margin: "0px 0px",
                                height: { xs: '34px', sm: '44px', md: '44px', lg: '44px' },
                                marginBottom: '0px',
                            }}

                        />
                    );

                })}
            </Stack>
            {formError && (
                // <Box sx={{ marginTop: "10px" }}>
                <Box sx={{ marginTop: isLargeScreen ? "8px" : "50px", display: "flex", justifyContent: "start" }}>
                    <CommonErrorMessage
                        text={formError}
                    />
                </Box >
            )
            }
            <ClientButton
                text="Next"
                onClick={handleNextStep}
                backgroundColor={theme.primaryColor}
                sx={{
                    maxWidth: "320px",
                    width: "100%",
                    marginTop: { xs: '4px', sm: '30px', md: '20px', lg: "20px" },
                }}
            />
            <Button
                onClick={onClickSkip}
                sx={{
                    mt: "6px",
                    color: "#A1A0A0",
                    fontSize: { xs: '15px', sm: '17px' },
                    fontWeight: "600",
                    '&:hover': {
                        color: '#ee5c36',
                        backgroundColor: 'transparent'
                    }
                }}
            >
                No, skip
            </Button>
        </>
    );
}
